import React, {Component} from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

import PurchaseList from "./PurchaseScreen/PurchaseList.js"

import api from "../api.js"

/**
 * onSelectClick(purchase)
 * onCancelClick()
 */

class SelectPurchaseDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selected: undefined,
            purchases: [],
        }

        this.handle_selectPurchase = this.handle_selectPurchase.bind(this)
    }

    async componentDidMount() {
        await this.update()
    }

    update = () => api.purchases.list()
        .then(response => this.setState({purchases: response.purchases}))

    handle_selectPurchase(purchase) {
        if (typeof this.props.onSelectClick === "function") {
            this.props.onSelectClick(this.state.selected)
        }
    }

    render() {
        return <Dialog open fullWidth>
            <DialogTitle>Выбор закупки</DialogTitle>
            <DialogContent>
                <PurchaseList 
                    width_auto
                    hide_complete_buttons
                    purchases={this.state.purchases}
                    selected={this.state.selected}
                    onPurchaseClick={purchase=>this.setState({selected: purchase})}
                    onPurchaseDoubleClick={this.handle_selectPurchase}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={!this.state.selected}
                    onClick={e=>{
                        e.stopPropagation()
                        this.handle_selectPurchase(this.state.selected)
                    }}
                >Выбрать</Button>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick(this.state.selected)
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default SelectPurchaseDialog